import Vue from 'vue'
import Router from 'vue-router'

import Service from "./services";

const MainLayout = () => import('@/layouts/MainLayout.vue')
const Login = () => import('@/views/Login.vue')
const TemporaryDisable = () => import('@/views/TemporaryDisable.vue')
const Home = () => import('@/views/Home.vue')
const LiveOrders = () => import('@/views/order/Live.vue')
const ScheduledOrders = () => import('@/views/order/Scheduled.vue')
const ClusterOrders = () => import('@/views/order/Cluster.vue')
const CreateOrder = () => import('@/views/order/Create.vue')
const ViewOrder = () => import('@/views/order/Detail.vue')
const ViewShop = () => import('@/views/shop/Detail.vue')
const ViewEnterprise = () => import('@/views/enterprise/Detail.vue')
const ViewProduct = () => import('@/views/product/Detail.vue')

const ShopsList = () => import('@/views/shop/List.vue')
const ProductList = () => import('@/views/product/List.vue')
const EnterprisesList = () => import('@/views/enterprise/List.vue')


const Drivers = () => import('@/views/driver/Index.vue')
const DriversMap = () => import('@/views/driver/Map.vue')
const PoiList = () => import('@/views/poi/List.vue')
const PoiDetail = () => import('@/views/poi/Detail.vue')
const PostList = () => import('@/views/post/List.vue')
const PostCreate = () => import('@/views/post/Create.vue')
const PostDetail = () => import('@/views/post/Detail.vue')

const CommerceOrders = () => import('@/views/commerce/order/Live.vue')
const CommerceViewOrder = () => import('@/views/commerce/order/Detail.vue')
const CreateCommerceOrder = () => import('@/views/commerce/order/Create.vue')

const CommerceProducts = () => import('@/views/commerce/product/List.vue')
const CreateCommerceProduct = () => import('@/views/commerce/product/Create.vue')

const HeatMap = () => import('@/views/report/HeatMap2.vue')
const SaleReport = () => import('@/views/report/Sale.vue')
const ProductReport = () => import('@/views/report/Product.vue')
const ShopReport = () => import('@/views/report/Shop.vue')
const CategoryReport = () => import('@/views/report/Category.vue')

const SocialFacebook = () => import('@/views/social/Facebook.vue')

const Company = () => import('@/views/Company.vue')

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/temporary-disable',
      name: 'temporary-disable',
      component: TemporaryDisable,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/',
      name: "MainLayout",
      component: MainLayout,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '/',
          name: 'Home',
          component: Home
        },
        {
          path: '/orders/live',
          name: 'LiveOrders',
          component: LiveOrders
        },
        {
          path: '/orders/schedule',
          name: 'ScheduleOrders',
          component: ScheduledOrders
        },
        {
          path: '/orders/cluster',
          name: 'ClusterOrders',
          component: ClusterOrders,
          props: true,
        },
        {
          path: '/create/order',
          name: 'CreateOrder',
          component: CreateOrder,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/view/order/:order_ref',
          name: 'ViewOrder',
          component: ViewOrder,
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/view/shop/:ref_no',
          name: 'ViewShop',
          component: ViewShop,
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/view/enterprise/:reference',
          name: 'ViewEnterprise',
          component: ViewEnterprise,
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/view/product/:product_id',
          name: 'ViewProduct',
          component: ViewProduct,
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/shops',
          name: 'ShopsList',
          component: ShopsList
        },
        {
          path: '/pois',
          name: 'PoiList',
          component: PoiList
        },
        {
          path: '/pois/view/:poi_id',
          name: 'PoiDetail',
          component: PoiDetail,
          props: true,
        },
        {
          path: '/products',
          name: 'ProductList',
          component: ProductList
        },
        {
          path: '/drivers/list',
          name: 'Drivers',
          component: Drivers,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/drivers/map',
          name: 'DriversMap',
          component: DriversMap,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/posts',
          name: 'PostList',
          component: PostList
        },
        {
          path: '/posts/create',
          name: 'PostCreate',
          component: PostCreate,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/posts/:post_slug',
          name: 'PostDetail',
          component: PostDetail,
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/social/facebook',
          name: 'SocialFacebook',
          component: SocialFacebook,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/enterprises',
          name: 'EnterprisesList',
          component: EnterprisesList,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/report/heatmap',
          name: 'HeatmapReport',
          component: HeatMap,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/report/sale',
          name: 'SaleReport',
          component: SaleReport,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/report/category',
          name: 'CategoryReport',
          component: CategoryReport,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/report/shop',
          name: 'ShopReport',
          component: ShopReport,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/report/product',
          name: 'ProductReport',
          component: ProductReport,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/commerce/orders/live',
          name: 'CommerceOrders',
          component: CommerceOrders,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/commerce/create/order',
          name: 'CreateCommerceOrder',
          component: CreateCommerceOrder,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/commerce/view/order/:order_ref',
          name: 'CommerceViewOrder',
          component: CommerceViewOrder,
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/commerce/products',
          name: 'CommerceProducts',
          component: CommerceProducts,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/commerce/create/product',
          name: 'CreateCommerceProduct',
          component: CreateCommerceProduct,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/company',
          name: 'Company',
          component: Company,
          meta: {
            requiresAuth: true
          }
        },
      ]
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {

    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);

    if (!localStorage.getItem("halalize")) {
      next({
        path: "/login",
        params: {
          nextUrl: to.fullPath
        }
      });
    } else {

      let vuex = JSON.parse(localStorage.getItem("halalize"));
      let accessToken = vuex.Auth.accessToken;

      Service.Auth
        .me(accessToken)
        .then(response => {
          if (response.status != 'ok') {
            next({
              path: "/login",
              params: {
                nextUrl: to.fullPath
              }
            });
          } else {
            Service.User.me().then(rs => {
              if (rs.data.errors.length > 0) {
                next({
                  path: "/temporary-disable"
                });
              }
              else {
                next();
              }
            })

            next();
            /*
            Service.User.permission().then(resp => {
              if (resp.success) {
                vuex.Auth.permission = resp.data
                localStorage.setItem('halalize', JSON.stringify(vuex))
                next();
              }
            }).catch(err => {
              next({
                path: "/login",
                params: {
                  nextUrl: to.fullPath
                }
              });
            })
            */
          }
        })
        .catch(err => {
          next({
            path: "/login",
            params: {
              nextUrl: to.fullPath
            }
          });
        });
    }
  } else {
    next();
  }

});


export default router;
